module.exports = __webpack_public_path__ + "img/Thailand Digital Arrival Card (TDAC)-en.138715b.png";